//import FetchAPI from '../features/userprofile/api/FetchAPI'
import LandingSearch from './LandingSearch';
import React from "react";


const BackgroundImage = () => {
  const bgImageStyle = {
    backgroundSize: '90%',
    backgroundRepeat: 'repeat-x',
    backgroundPositionX: 'center',
    backgroundPositionY: '70%',
    height: '100%',
    width: '100%',
    overflow: 'auto',
    backgroundColor: '#F7F7F5',
  };

  return (
    <div
      className="bg-image"
      style={bgImageStyle}
      >
       <LandingSearch/> 
    </div>
  );
};

export default BackgroundImage;
